import { Button, Checkbox, Modal } from "antd";
import React, { useState } from "react";

const ClearCDNCacheModal = ({ open, setOpen, onSubmit }) => {
    const [loading, setLoading] = useState(false);
    const [selectedDomains, setSelectedDomains] = useState([]);

    const availableDomains = ["plusbimeh.com", "bimeh.com"];

    const handleCheckboxChange = (domain, checked) => {
        setSelectedDomains(prev =>
            checked ? [...prev, domain] : prev.filter(d => d !== domain)
        );
    };

    const handleSubmit = async () => {
        if (selectedDomains.length === 0) return;
        setLoading(true);
        try {
            await onSubmit(selectedDomains);
            handleClose();
        } catch (error) {
            console.error("Error clearing CDN cache:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedDomains([]);
    };

    return (
        <Modal
            title="پاک‌سازی کش CDN"
            open={open}
            onCancel={handleClose}
            footer={[
                <Button key="cancel" onClick={handleClose} disabled={loading}>
                    انصراف
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    disabled={selectedDomains.length === 0 || loading}
                    onClick={handleSubmit}
                    loading={loading}
                >
                    پاک‌سازی ({selectedDomains.length})
                </Button>
            ]}
        >
            <div style={{ marginBottom: 16, color: "#666" }}>
                دامنه‌های مورد نظر برای پاک‌سازی کش را انتخاب کنید:
            </div>
            <div>
                {availableDomains.map((domain) => (
                    <div
                        key={domain}
                        style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0" }}
                    >
                        <Checkbox
                            checked={selectedDomains.includes(domain)}
                            onChange={(e) => handleCheckboxChange(domain, e.target.checked)}
                        >
                            {domain}
                        </Checkbox>
                    </div>
                ))}
            </div>
        </Modal>
    );
};

export default ClearCDNCacheModal;
